import { get } from "../../api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const getApplicationFeatures = () => get(`${url}/applicationFeatures/application-features`);

const exp = {
  getApplicationFeatures
};
export default exp;
